import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function AuditlogReducer(state = initialState.auditlog, action: any) {
  switch (action.type) {
    case types.SAVE_AUDITLOG_SUCCESS:
      return action.auditlog;
    default:
      return state;
  }
}
